document.querySelectorAll('.gm-item').forEach(item => {  
    item.addEventListener('click', function() {  
        // Remove 'active' class from any currently active items  
        document.querySelectorAll('.gm-item.active').forEach(activeItem => {  
            activeItem.classList.remove('active');  
        });  
        // Add 'active' class to the clicked item  
        this.classList.add('active');  
    });  
});  